import React, { useState } from 'react';
import { motion } from 'framer-motion';
const destinations = ['Costa Rica', 'Mexico', 'Portugal', 'Other'];
const cravings = ['Adventure', 'Rest', 'Creativity', 'Community', 'Culture', 'Reinvention', 'Founder', 'Not sure yet'];
const rooms = ['Shared', 'Private', 'Either'];
export function Waitlist() {
  const [submitted, setSubmitted] = useState(false);
  const [step, setStep] = useState(0);
  const [form, setForm] = useState({
    name: '',
    email: '',
    destination: '',
    craving: '',
    room: ''
  });
  const update = (k: string, v: string) => setForm(f => ({
    ...f,
    [k]: v
  }));
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // TODO: Connect to your email/waitlist provider here
    // - Mailchimp, ConvertKit, Tally, Google Forms, or custom backend
    console.log('Waitlist submission:', form);
    setSubmitted(true);
  };
  const canContinue = step === 0 && form.name && form.email || step === 1 && form.destination || step === 2 && form.craving || step === 3;
  return <section id="waitlist" className="relative py-28 md:py-40 px-6 md:px-12 bg-ink text-bone" data-id="element-191">
      <div className="relative max-w-xl mx-auto" data-id="element-192">
        <div className="text-center mb-14" data-id="element-193">
          <p className="eyebrow !text-sun mb-6" data-id="element-194">Request an invitation</p>
          <motion.h2 initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.9
        }} className="font-serif-display text-3xl md:text-5xl leading-[1.05] text-bone" data-id="element-195">
            A few quiet questions, <br data-id="element-196" />
            <span className="italic text-sun" data-id="element-197">and you're in.</span>
          </motion.h2>
        </div>

        {submitted ? <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.7
      }} className="border-y border-bone/15 py-16 text-center" data-id="element-198">
            <p className="eyebrow !text-sun mb-5" data-id="element-199">You're in</p>
            <p className="font-serif-display italic text-bone text-2xl md:text-4xl" data-id="element-200">
              We'll be in touch — quietly.
            </p>
          </motion.div> : <form onSubmit={handleSubmit} className="border-y border-bone/15 py-12 md:py-14" data-id="element-201">
            {/* Progress */}
            <div className="flex gap-2 mb-12" data-id="element-202">
              {[0, 1, 2, 3].map(s => <div key={s} className={`h-px flex-1 transition-colors duration-500 ${s <= step ? 'bg-sun' : 'bg-bone/20'}`} data-id="element-203" />)}
            </div>

            <div className="min-h-[260px] flex flex-col justify-center" data-id="element-204">
              {step === 0 && <motion.div key="step-0" initial={{
            opacity: 0,
            y: 8
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5
          }} className="space-y-8" data-id="element-205">
                  <p className="font-serif-display italic text-bone text-xl md:text-2xl" data-id="element-206">
                    First, who are you?
                  </p>
                  <div className="grid md:grid-cols-2 gap-8" data-id="element-207">
                    <Input label="Name" value={form.name} onChange={v => update('name', v)} data-id="element-208" />
                    <Input label="Email" type="email" value={form.email} onChange={v => update('email', v)} data-id="element-209" />
                  </div>
                </motion.div>}
              {step === 1 && <motion.div key="step-1" initial={{
            opacity: 0,
            y: 8
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5
          }} className="space-y-8" data-id="element-210">
                  <p className="font-serif-display italic text-bone text-xl md:text-2xl" data-id="element-211">
                    Where do you dream of going first?
                  </p>
                  <ChipGroup options={destinations} value={form.destination} onChange={v => update('destination', v)} data-id="element-212" />
                </motion.div>}
              {step === 2 && <motion.div key="step-2" initial={{
            opacity: 0,
            y: 8
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5
          }} className="space-y-8" data-id="element-213">
                  <p className="font-serif-display italic text-bone text-xl md:text-2xl" data-id="element-214">
                    What are you craving most?
                  </p>
                  <ChipGroup options={cravings} value={form.craving} onChange={v => update('craving', v)} data-id="element-215" />
                </motion.div>}
              {step === 3 && <motion.div key="step-3" initial={{
            opacity: 0,
            y: 8
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5
          }} className="space-y-8" data-id="element-216">
                  <p className="font-serif-display italic text-bone text-xl md:text-2xl" data-id="element-217">
                    Preferred room?
                  </p>
                  <ChipGroup options={rooms} value={form.room} onChange={v => update('room', v)} data-id="element-218" />
                </motion.div>}
            </div>

            <div className="mt-12 flex items-center justify-between gap-6" data-id="element-219">
              <button type="button" onClick={() => setStep(s => Math.max(0, s - 1))} className={`eyebrow !text-bone/50 hover:!text-bone transition-colors ${step === 0 ? 'invisible' : ''}`} data-id="element-220">
                ← Back
              </button>

              {step < 3 ? <button type="button" onClick={() => canContinue && setStep(s => s + 1)} disabled={!canContinue} className="px-10 py-4 bg-sun text-ink text-[11px] uppercase tracking-[0.32em] hover:bg-bone transition-colors duration-500 disabled:opacity-30 disabled:cursor-not-allowed" data-id="element-221">
                  Continue
                </button> : <button type="submit" disabled={!form.room} className="px-10 py-4 bg-sun text-ink text-[11px] uppercase tracking-[0.32em] hover:bg-bone transition-colors duration-500 disabled:opacity-30 disabled:cursor-not-allowed" data-id="element-222">
                  Request Invitation
                </button>}
            </div>
          </form>}

        <p className="mt-8 text-center eyebrow !text-bone/40" data-id="element-223">
          No spam. Only thoughtful updates.
        </p>
      </div>
    </section>;
}
function Input({
  label,
  value,
  onChange,
  type = 'text'
}: {
  label: string;
  value: string;
  onChange: (v: string) => void;
  type?: string;
}) {
  return <label className="block" data-id="element-224">
      <span className="eyebrow !text-bone/50 block mb-3" data-id="element-225">{label}</span>
      <input type={type} required value={value} onChange={e => onChange(e.target.value)} className="w-full bg-transparent border-b border-bone/30 focus:border-sun outline-none py-2 text-bone text-base" data-id="element-226" />
    </label>;
}
function ChipGroup({
  options,
  value,
  onChange
}: {
  options: string[];
  value: string;
  onChange: (v: string) => void;
}) {
  return <div className="flex flex-wrap gap-2" data-id="element-227">
      {options.map(o => {
      const active = value === o;
      return <button type="button" key={o} onClick={() => onChange(o)} className={`px-5 py-2.5 text-[12px] tracking-wide border transition-all duration-300 ${active ? 'bg-sun text-ink border-sun' : 'bg-transparent text-bone/70 border-bone/25 hover:border-bone hover:text-bone'}`} data-id="element-228">
            {o}
          </button>;
    })}
    </div>;
}